/* Blink Box USP navigation enhancement.
   Server-rendered claims are static without JavaScript or a matching tab.
   Only enhance available actions into native buttons. */
(() => {
  const init = (scope = document) => {
    const root = document.getElementById('product-delivery-shipping');
    if (!root) return;
    const disclosure = root.closest('details-disclosure');
    const tab = root.closest('[role="tab"]');
    if (!disclosure && !tab) return;

    const nodes = [
      ...(scope.matches?.('[data-usp-details-trigger]') ? [scope] : []),
      ...scope.querySelectorAll('[data-usp-details-trigger]')
    ];

    nodes.forEach((node) => {
      if (node.tagName === 'BUTTON') return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = node.className;
      button.classList.add('is-enabled');
      button.dataset.uspDetailsTrigger = '';
      button.setAttribute('aria-label', node.dataset.uspAccessibleLabel);
      while (node.firstChild) button.appendChild(node.firstChild);
      node.replaceWith(button);
    });
  };

  if (window.BlinkBoxProductUSPsInit) {
    window.BlinkBoxProductUSPsInit();
    return;
  }

  window.BlinkBoxProductUSPsInit = init;

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element
      ? event.target.closest('button[data-usp-details-trigger]')
      : null;
    if (!button) return;
    const target = document.getElementById('product-delivery-shipping');
    if (!target) return;

    const disclosure = target.closest('details-disclosure');
    const tab = target.closest('[role="tab"]');
    if (!disclosure && !tab) return;

    if (disclosure) {
      const details = disclosure.querySelector('details');
      if (details && !details.open) {
        if (typeof disclosure.open === 'function') disclosure.open();
        else details.open = true;
      }
    }
    if (tab && tab.getAttribute('aria-selected') !== 'true') tab.click();

    const focusTarget = tab || target;
    requestAnimationFrame(() => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      focusTarget.focus({ preventScroll: true });
      focusTarget.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();